import { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import {
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { FaAngleDown } from "react-icons/fa";

import GeneralBtn from "../generalBtn";

interface PaginationProps {
  handlePreviousButton: () => void;
  handleNextButton: () => void;
  handleClickPage: (value: number) => void;
  isJobPage: boolean;
  setIsJobPage: Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  totalPages: number;
  pageSize: number;
}

const Pagination = ({
  handlePreviousButton,
  handleNextButton,
  handleClickPage,
  isJobPage,
  setIsJobPage,
  currentPage,
  totalPages,
  pageSize,
}: PaginationProps) => {
  // const dispatch = useDispatch<AppDispatch>();

  // Open job per page dropdown
  const handleJobPerPage = () => {
    setIsJobPage(!isJobPage);
  };

  return (
    <PaginationWrapper>
      <GeneralBtn
        icon={<MdOutlineKeyboardDoubleArrowLeft />}
        handleClick={handlePreviousButton}
        btnStyle={`pagination__btn ${
          currentPage === 1 ? "add__prev__page" : ""
        }`}
        // btnContent={""}
        disabled={currentPage === 1}
      />

      <p className="current__page">{currentPage}</p>

      <GeneralBtn
        icon={<MdOutlineKeyboardDoubleArrowRight />}
        handleClick={handleNextButton}
        btnStyle={`pagination__btn ${
          currentPage === totalPages || totalPages === 0
            ? "add__next__page"
            : ""
        }`}
        // btnContent={""}
        disabled={currentPage === totalPages || totalPages === 0}
      />
      <div style={{ position: "relative" }}>
        <GeneralBtn
          icon={<FaAngleDown />}
          handleClick={handleJobPerPage}
          btnStyle={`pagination__btn job__per__page`}
          btnContent={`Jobs per page (${pageSize})`}
          // disabled={currentPage === totalPages}
          btnConStyle="pagination__btn__con"
        />
        {isJobPage && (
          <div className="per__page__dropdown">
            <p onClick={() => handleClickPage(10)}>Show 10 jobs per page</p>
            <p onClick={() => handleClickPage(20)}>Show 20 jobs per page</p>
            <p onClick={() => handleClickPage(30)}>Show 30 jobs per page</p>
            <p onClick={() => handleClickPage(40)}>Show 40 jobs per page</p>
          </div>
        )}
      </div>
    </PaginationWrapper>
  );
};

export default Pagination;

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-block: 3rem 2rem;
  width: fit-content;
  margin-inline: auto;

  .current__page {
    font-weight: 600;
    font-size: 28px;
  }

  .pagination__btn {
    width: fit-content;
    padding-inline: 8px;
    font-size: 28px;
    border-radius: 6px;
    flex-direction: row-reverse;
  }

  .pagination__btn__con {
    /* border: 2px solid red; */
    display: flex;
  }

  .add__prev__page {
    opacity: 0.4;
  }
  .add__next__page {
    opacity: 0.4;
  }
  .job__per__page {
    font-size: 1rem;
  }

  .per__page__dropdown {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: absolute;
    width: max-content;
    padding: 8px;
    margin-block: 2px 1rem;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  .per__page__dropdown > p {
    cursor: pointer;
    padding: 4px 8px;
  }
  .per__page__dropdown > p:hover {
    background-color: #e8e6e6;
  }

  @media screen and (max-width: 540px) {
    gap: 8px;

    .current__page {
      font-size: 20px;
      margin-inline: 4px;
    }
    .pagination__btn {
      padding-inline: 4px;
      font-size: 20px;
    }
    .job__per__page {
      font-size: 14px;
    }
    .per__page__dropdown {
      right: 0px;
      width: max-content;
      padding-inline: 6px;
    }
  }
`;
